export const SPONSORS_CONSTS = {
    GET_SPONSORS:"GET_SPONSORS",
    CREATE_SPONSOR_ITEM:"CREATE_SPONSOR_ITEM",
    UPDATE_SPONSOR_ITEM: "UPDATE_SPONSOR_ITEM",
    DELETE_SPONSOR_ITEM: "DELETE_SPONSOR_ITEM",
};